import './Onboarding.sass';
import { observer } from 'mobx-react-lite';
import { useTheme } from '@mui/material/styles';
import React, { useState, useEffect, useRef } from 'react';
import MobileStepper from '@mui/material/MobileStepper';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import ClearIcon from '@mui/icons-material/Clear';

import {
  Autocomplete,
  Box,
  Select,
  Button,
  Grid,
  CircularProgress,
  Input,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  InputAdornment,
  InputLabel,
  MenuItem,
  TextField,
  Typography,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Tooltip,
  Divider
} from '@mui/material';
import { NavLink } from 'react-router-dom';

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
// import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';

import agent from '../../lib/agent';
import LayoutContent from '../../components/layout/LayoutContent';
import LayoutPanel from '../../components/layout/LayoutPanel';
import ArcLogo from '../../assets/arcgis-logo.png';
import GridmarketLogo from '../../assets/gridmarket-logo.svg';
import useStores from '../../stores/useStores';
import useInterval from '../../lib/useInterval';

const Onboarding = ({
  onboardingAnswers = {},
  history,
  match,
  onboardingStep = 1
}) => {
  const theme = useTheme();
  const [step, setStep] = useState(onboardingStep);
  const [activeStep, setActiveStep] = useState(0);
  const [registrationForm, setRegistrationForm] = useState({
    email: '',
    password: '',
    name: '',
    phone: ''
  });
  const [options, setOptions] = useState([]);
  const [selectedGoals, setSelectedGoals] = useState([]);
  const [autoInputValue, setAutoInputValue] = React.useState('');

  const { userStore } = useStores();
  const [pickedAddress, setPickedAddress] = useState(null);
  const [userId, setUserId] = useState(null);
  const [error, setError] = useState({});
  const [addressError, setAddressError] = useState(false);
  const { token } = match.params;
  const emailInput = useRef(null);
  const passwordInput = useRef(null);
  const passwordRepeatInput = useRef(null);
  const honeyPotInput = useRef(null);

  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState('');
  const [selectedAddresses, setSelectedAddresses] = useState([]);
  const [loading, setLoading] = useState(false);

  const { uiStore } = useStores();
  const { REGISTRATION_VERSION } = uiStore;

  const handleBack = () => {
    setAddressError(false);
    if (step === 3) {
      setStep(6);
      return;
    }
    setActiveStep(prevActiveStep => prevActiveStep - 1);
    setStep(step - 1);
  };

  const handleSkip = () => {
    agent.User.submitOnboardingAnswer('skipped', 'true', userId);
    agent.User.onboardingComplete();
    handleBack();
  };

  const [formState, setFormState] = useState({
    userType: '',
    quantity: '',
    orgType: '',
    explanation: '',
    orgName: '',
    title: '',
    goals: [],
    budget: '',
    annualEnergyCost: '',
    annualEnergyUse: '',
    utility: '',
    lotSize: '',
    roofSize: '',
    ownOrLease: '',

    ...onboardingAnswers
  });

  const [uploadedData, setUploadedData] = useState([]);
  const [otherOrg, setOtherOrg] = useState(false);
  const [isEmployee, setIsEmployee] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(0);
  const [isFormValid, setIsFormValid] = useState(false);

  const questions = [
    {
      question:
        'How many properties that you manage are interested in distributed energy projects?',
      name: 'quantity',
      options: ['1-5', '6-10', '11-50', '50+']
    },
    {
      question: 'For whom do you manage the properties?',
      name: 'orgType',
      options: [
        'Myself/My Family',
        'The organization I work for',
        'For a client or a friend',
        'Other'
      ],
      other: ['Please Explain', 'explanation'],
      employee: [
        'What organization do you work for?',
        'orgName',
        'What is your title in that organization',
        'title'
      ]
    },
    {
      question: 'What are your goals with your energy project(s)?',
      name: 'goals',

      options: [
        'Energy Cost Reduction',
        'Regulatory Compliance',
        'Fleet Electrification',
        'Electricity Resilience',
        'Environmental, Social, Governance (ESG)',
        'Other',
        "Don't Know"
      ]
    }
  ];

  useEffect(() => {
    if (formState.orgType === 'The organization I work for') {
      setIsEmployee(true);
    } else {
      setIsEmployee(false);
    }

    if (formState.orgType === 'Other') {
      setOtherOrg(true);
    } else {
      setOtherOrg(false);
    }
  }, [formState.orgType]);

  useEffect(() => {
    if (step === 3) {
      setActiveStep(1);
    }
    if (step === 4) {
      setActiveStep(1);
    }
    if (step === 5) {
      setActiveStep(2);
    }
    if (step === 6) {
      setActiveStep(3);
    }
  }, [step]);

  useInterval(() => {
    if (!userStore.isActivated && step === 5) {
      userStore.fetchCredentials();
    }

    if (!userStore.isOnboardingCompleted && step === 5) {
      (async () => {
        await agent.User.onboardingComplete();
      })();
    }
  }, 5000);

  const handleGoalsBlur = () => {
    agent.User.submitOnboardingAnswer('goals', formState.goals, userId);
  };

  const goalsOptions = [
    'Energy Cost Reduction',
    'Regulatory Compliance',
    'Fleet Electrification',
    'Electricity Resilience',
    'Environmental, Social, Governance (ESG)',
    'Other',
    "Don't Know"
  ];

  const handleRegisterChange = e => {
    setRegistrationForm(registrationForm => {
      return {
        ...registrationForm,
        [e.target.name]: e.target.value
      };
    });
    e.preventDefault();
    if (
      registrationForm.email &&
      // registrationForm.name &&
      registrationForm.password
    ) {
      setIsFormValid(true);
    }
  };

  const nextStep = () => {
    setStep(step + 1);
  };

  const handleRegistrationQuizSubmission = e => {
    agent.User.submitOnboardingAnswer(e.target.name, e.target.value, userId);
  };

  const handleRegistration = async () => {
    const buildingsArray = [];
    for (let i = 0; i < selectedAddresses.length; i += 1) {
      buildingsArray.push(selectedAddresses[i].id);
    }
    const postBody = {
      name: 'My first project',
      buildings: buildingsArray
    };
    if (formState.orgName) {
      postBody.group = {
        name: formState.orgName
      };
    }

    try {
      await agent.User.createSignupProject({
        ...postBody,
        user_id: userId
      });
    } catch (err) {
      setTimeout(() => {
        console.error(err);
      }, 4000);
      setAddressError(true);
      return;
    }

    nextStep();
  };

  const handleNext = async () => {
    if (step === 7 && userStore.isActivated) {
      history.push('/');
    }

    if (step === 5 && REGISTRATION_VERSION === 'v2') {
      setTimeout(handleRegistration(), 2000);
    }
    if (step !== 7) {
      setActiveStep(activeStep + 1);
      nextStep();
    }
  };

  const handleRegister = async e => {
    e.preventDefault();
    const response = await agent.User.signup(registrationForm);
    if (response.data.ok) {
      setUserId(response.data.id);
      setStep(3);
    }

    if (!response.data.ok) {
      if (response.data.err.user) {
        setError({
          email: 'A user already exists with this email'
        });
      }
      if (response.data.err.email) {
        setError({
          email: 'Please check the formatting of your email address'
        });
      }
      if (response.data.err.password) {
        setError({
          password: 'Your password must have a minimum of 6 characters'
        });
      }
    }
  };

  const handleChange = e => {
    e.preventDefault();
    setFormState({ ...formState, [e.target.name]: e.target.value });
    if (formState.orgType === 'The organization I work for') {
      setIsEmployee(true);
    } else {
      setIsEmployee(false);
    }

    if (formState.orgType === 'Other') {
      setOtherOrg(true);
    } else {
      setOtherOrg(false);
    }
  };

  const handlePasswordResetSubmit = event => {
    event.preventDefault();
    const email = emailInput.current.value;
    agent.User.sendPasswordResetEmail(email);
    // setPasswordResetEmailSent(true);
    setForgotPassword(2);
  };

  const addressAddTimer = result => {
    const selected = result;
    setTimeout(() => {
      setLoading(false);
      setTimeout(() => {
        setValue('');
        setLoading(true);
        setPickedAddress('');
        if (selected) {
          setUploadedData(uploadedData => [...uploadedData, selected]);
        }
      }, 600);
    }, 1100);
    setLoading(true);
  };

  const deleteAddress = e => {
    const deletedFile = e.target.getAttribute('row');

    setUploadedData(uploadedData.filter(address => address !== deletedFile));
    setSelectedAddresses(
      selectedAddresses.filter(address => address.address !== deletedFile)
    );
  };

  const handleLoginSubmit = async e => {
    e.preventDefault();
    // if (honeyPotInput?.current?.value) return;

    if (token) {
      const newPassword = passwordInput.current.value;
      const newPasswordRepeat = passwordRepeatInput.current.value;
      if (newPassword !== newPasswordRepeat) {
        setError({
          'password-repeat': 'The password confirmation does not match'
        });
        return;
      }
      setError({});
      /*
      const { data } = await axios.post(`/reset/${token}`, {
        password: newPassword,
        token
      });
      */

      // if (data.ok) {
      //   return history.push('/');
      // }
    }

    const email = emailInput.current.value;
    const password = passwordInput.current.value;
    const success = await userStore.login(email, password);
    if (!success) {
      setError({
        'password-error': 'Wrong username/password combination'
      });
      passwordInput.current.value = '';
    } else {
      history.push(location.state?.referrer || '/');
    }
  };

  useEffect(() => {
    if (inputValue.length < 3) return;
    (async () => {
      const response = await agent.Address.autocomplete(inputValue);
      // console.log(response, 'response from autocomplete');
      setOptions(response.data.data);
    })();
  }, [inputValue]);

  return (
    <LayoutContent
      panel={
        <LayoutPanel>
          <Box className="onboarding-container">
            <Box className="content-container  scrollBarsHidden">
              <Box className="logoBox">
                <Box
                  component="img"
                  src={GridmarketLogo}
                  className="gridmarket-logo"
                />
                {step > 2 && (
                  <>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                      Registration
                    </Typography>
                    <Typography variant="body">
                      Step {activeStep + 1} of 4
                    </Typography>
                  </>
                )}
              </Box>
              {step === 0 && (
                <Box className="login-selection content">
                  <Typography variant="h6" sx={{ mb: 5 }}>
                    Log In Or Sign Up
                  </Typography>
                  <Box>
                    <Button
                      variant="outlined"
                      org="ArcGIS"
                      fullWidth="true"
                      component={NavLink}
                      to="/auth/arcgis"
                      sx={{ p: 1, mt: 1, textTransform: 'none' }}
                      startIcon={
                        <img src={ArcLogo} className="arc-logo" alt="ArcGis" />
                      }
                    >
                      Continue with ArcGIS
                    </Button>
                    <Button
                      variant="outlined"
                      fullWidth="true"
                      onClick={nextStep}
                      org="ArcGIS"
                      sx={{ p: 1, mt: 1, textTransform: 'none' }}
                      startIcon={<MailOutlineIcon className="email-icon" />}
                    >
                      Continue with Email
                    </Button>
                  </Box>
                  {/* <Link
                    sx={{ mt: 5 }}
                    href="https://gridmarket.com/vendors/#tve-jump-174c75589ff"
                  >
                    Vendor Login and Registration
                  </Link> */}
                </Box>
              )}
              {step === 1 && forgotPassword === 0 && (
                <Box className="content login">
                  <form onSubmit={handleLoginSubmit} className="content">
                    <Typography variant="h6">Sign in</Typography>
                    <FormControl margin="normal" required fullWidth>
                      <InputLabel htmlFor="email">Email Address</InputLabel>
                      <Input
                        inputRef={emailInput}
                        id="email"
                        name="email"
                        autoComplete="email"
                        autoFocus
                      />
                    </FormControl>
                    <FormControl margin="normal" required fullWidth>
                      <InputLabel htmlFor="password">Password</InputLabel>
                      <Input
                        inputRef={passwordInput}
                        name="password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                      />
                      <FormHelperText error>
                        {error['password-error']}
                      </FormHelperText>
                    </FormControl>
                    <FormControl
                      style={{
                        transform: 'translateX(-10000px)',
                        height: 1,
                        margin: 0,
                        overflow: 'hidden',
                        position: 'fixed'
                      }}
                      fullWidth
                    >
                      <Input
                        style={{
                          transform: 'translateX(-10000px)',
                          height: 1,
                          display: 'none'
                        }}
                        inputRef={honeyPotInput}
                        name="password"
                        type="password"
                        id="password"
                        autoComplete="new-password"
                      />
                    </FormControl>
                    <Grid
                      justifyContent="flex-end"
                      alignItems="right"
                      container
                      spacing={3}
                    >
                      <Grid item sx={{ mb: 3 }}>
                        <Button
                          sx={{ textTransform: 'none' }}
                          onClick={() => setForgotPassword(1)}
                        >
                          Forgot your password?
                        </Button>
                      </Grid>
                    </Grid>

                    <Box className="content">
                      <Button
                        type="submit"
                        className="round-button"
                        sx={{ m: 2 }}
                      >
                        Sign In
                      </Button>
                      <Typography
                        sx={{
                          display: 'none'
                        }}
                        m={3}
                        color="gray"
                      >
                        - or -
                      </Typography>
                      {/* <Button
                        sx={{
                          textDecoration: 'underline',
                          textTransform: 'none',
                          fontSize: 15
                        }}
                        onClick={nextStep}
                      >
                        Register as a new user
                      </Button> */}
                    </Box>
                    <Box
                      sx={{
                        display: 'none'
                      }}
                    >
                      <Button
                        variant="outlined"
                        org="ArcGIS"
                        fullWidth="true"
                        component={NavLink}
                        to="/auth/arcgis"
                        sx={{ textTransform: 'none' }}
                        startIcon={
                          <img
                            src={ArcLogo}
                            width={27}
                            height={27}
                            alt="ArcGIS"
                          />
                        }
                      >
                        Continue with ArcGIS
                      </Button>
                    </Box>
                  </form>
                  <Box
                    sx={{
                      width: '100%',
                      textAlign: 'center'
                    }}
                  >
                    <Divider variant="middle" sx={{ mt: 4, mb: 2 }} />
                    <Typography
                      variant="body"
                      sx={{
                        textAlign: 'center',
                        width: '100%',
                        letterSpacing: '0.04rem',
                        display: 'flex',
                        alignContent: 'center',
                        alignItems: 'baseline',
                        justifyContent: 'center'
                      }}
                    >
                      Don&apos;t have an account?{' '}
                      <Button
                        variant="text"
                        disableRipple
                        sx={{
                          font: 'inherit',
                          fontWeight: 600,
                          textTransform: 'none',
                          '&:hover': {
                            backgroundColor: 'transparent'
                          }
                        }}
                        onClick={nextStep}
                      >
                        Sign up.
                      </Button>
                    </Typography>
                  </Box>
                </Box>
              )}
              {step === 1 && forgotPassword === 1 && (
                <Box className="content login">
                  <>
                    <Button
                      size="large"
                      sx={{ alignSelf: 'start', textTransform: 'none' }}
                      onClick={() => {
                        setForgotPassword(0);
                      }}
                    >
                      {theme.direction === 'rtl' ? (
                        <KeyboardArrowRight />
                      ) : (
                        <KeyboardArrowLeft />
                      )}
                      Back
                    </Button>
                    <Typography align="center" variant="h6">
                      Reset your password
                    </Typography>
                    <Typography gutterBottom align="center" variant="body2">
                      Type in your e-mail and we&apos;ll send you the link to
                      reset your password
                    </Typography>
                    <FormControl margin="normal" required fullWidth>
                      <InputLabel htmlFor="email">Email Address</InputLabel>
                      <Input
                        inputRef={emailInput}
                        id="email"
                        name="email"
                        autoComplete="email"
                        type="email"
                        sx={{ mb: 4 }}
                        autoFocus
                      />
                    </FormControl>
                    <Button
                      type="submit"
                      onClick={handlePasswordResetSubmit}
                      className="round-button"
                    >
                      Send
                    </Button>
                  </>
                </Box>
              )}
              {step === 1 && forgotPassword === 2 && (
                <Box className="content login">
                  <Typography align="center" variant="h6" gutterBottom>
                    Password reset e-mail has been sent
                  </Typography>
                  <Typography
                    gutterBottom
                    align="center"
                    variant="body2"
                    sx={{ mb: 2, mt: 2 }}
                  >
                    Password reset e-mail has been sent to you, check your
                    e-mail
                  </Typography>
                  <Typography align="center" variant="body2">
                    <Button onClick={() => setForgotPassword(0)}>
                      Back to login
                    </Button>
                  </Typography>
                </Box>
              )}
              {step === 2 && (
                <Box className="content login">
                  <form
                    onChange={handleRegisterChange}
                    onSubmit={handleRegister}
                  >
                    <Button
                      size="large"
                      sx={{ alignSelf: 'start', textTransform: 'none' }}
                      onClick={handleBack}
                    >
                      {theme.direction === 'rtl' ? (
                        <KeyboardArrowRight />
                      ) : (
                        <KeyboardArrowLeft />
                      )}
                      Back
                    </Button>
                    {/* <Typography
                      variant="h6"
                      align="center"
                      sx={{ mb: 2, mt: 3, fontWeight: 'bold' }}
                    >
                      Property Manager Registration
                    </Typography> */}

                    <FormGroup sx={{ mb: 3 }}>
                      {/* <FormControl margin="normal" required fullWidth>
                        <InputLabel htmlFor="fullName">Full Name</InputLabel>
                        <Input
                          id="name"
                          name="name"
                          autoComplete="name"
                          autoFocus
                        />
                      </FormControl> */}
                      <FormControl margin="normal" required fullWidth>
                        <InputLabel htmlFor="email">Email Address</InputLabel>
                        <Input
                          id="email"
                          name="email"
                          type="email"
                          autoComplete="email"
                        />
                        <FormHelperText error>{error.email}</FormHelperText>
                      </FormControl>
                      {/* <FormControl margin="normal" fullWidth>
                        <InputLabel htmlFor="phone">Phone</InputLabel>
                        <Input id="phone" name="phone" autoComplete="tel" />
                      </FormControl> */}
                      <FormControl margin="normal" required fullWidth>
                        <InputLabel htmlFor="password">Password</InputLabel>
                        <Input
                          id="password"
                          type="password"
                          name="password"
                          autoComplete="new-password"
                        />
                        <FormHelperText error>{error.password}</FormHelperText>
                      </FormControl>
                      {/* <Tooltip
                        title="Please complete all required fields"
                        arrow
                      >
                        <Button type="submit" disabled={!isFormValid}>
                          Register
                        </Button>
                      </Tooltip> */}
                      <Tooltip
                        title={
                          !isFormValid
                            ? 'Please complete all required fields'
                            : ''
                        }
                        className="content"
                        arrow
                      >
                        <span>
                          <Button
                            type="submit"
                            disabled={!isFormValid}
                            className="round-button"
                            color="primary"
                          >
                            Register
                          </Button>
                        </span>
                      </Tooltip>
                    </FormGroup>
                    {/* <Typography variant="body" className="content">
                      If you&apos;re a solution vendor&nbsp;
                      <Link
                        gutterBottom
                        href="https://gridmarket.com/vendors/#tve-jump-174c75589ff

"
                      >
                        register here instead
                      </Link>
                      {/* <Box
                        sx={{
                          display: 'flex',
                          alignContent: 'center',
                          justifyContent: 'center'
                        }}
                        onClick={handleBack}
                      >
                        <ArrowBackIcon /> Back to login
                      </Box> */}
                    {/* </Typography> */}
                  </form>
                </Box>
              )}
              {step === 3 && (
                <>
                  <Box className="form-container">
                    <Box className="content">
                      <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        What do you want to do?
                      </Typography>
                      <FormControl component="fieldset">
                        <RadioGroup
                          aria-labelledby="What do you want to do?"
                          name="userType"
                          sx={{ display: 'flex', flexDirection: 'row' }}
                          onBlur={handleRegistrationQuizSubmission}
                        >
                          <FormControlLabel
                            key="property manager"
                            value="property manager"
                            sx={{ m: 2 }}
                            control={<Radio />}
                            label={
                              <Typography variant="body1">
                                I want to get distributed energy solutions for
                                properties.
                              </Typography>
                            }
                            onChange={handleChange}
                          />
                          <FormControlLabel
                            key="vendor"
                            value="vendor"
                            control={<Radio />}
                            sx={{ m: 2 }}
                            label={
                              <Typography variant="body1">
                                I want to sell distributed energy solutions to
                                property owners.
                              </Typography>
                            }
                            onChange={handleChange}
                          />
                        </RadioGroup>
                      </FormControl>
                    </Box>
                  </Box>
                </>
              )}
              {step === 4 && formState.userType === 'vendor' && (
                <>
                  <Box className="content scrollBarsHidden">
                    <Box className="content">
                      <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Tell us a bit about yourself.
                      </Typography>
                      <TextField
                        label="Your Name"
                        name="name"
                        sx={{ mt: 2, width: '100%' }}
                      />
                      <TextField
                        label="Your Organization"
                        name="orgName"
                        sx={{ mt: 2, width: '100%' }}
                      />
                      <TextField
                        label="Your Title"
                        name="title"
                        sx={{ mt: 2, width: '100%' }}
                      />
                      <TextField
                        label="Your Phone Number"
                        name="phone"
                        sx={{ mt: 2, width: '100%' }}
                      />
                    </Box>
                  </Box>
                </>
              )}
              {step === 4 && formState.userType === 'property manager' && (
                <>
                  <Box className="content scrollBarsHidden">
                    <Box className="content">
                      {/* <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Property Manager Registration
                      </Typography>
                      <Typography variant="body">
                        Step {activeStep + 1} of 3
                      </Typography> */}
                      {REGISTRATION_VERSION === 'v1' && (
                        <Typography
                          variant="body"
                          align="center"
                          gutterBottom
                          sx={{
                            textAlign: 'justify',
                            fontWeight: '500',
                            mt: 5
                          }}
                        >
                          The next few questions will assist in setting up your
                          custom profile.
                        </Typography>
                      )}
                    </Box>

                    <Box className="form-container">
                      <form onSubmit={handleRegistrationQuizSubmission}>
                        {questions.map(question =>
                          question.question ===
                          'What are your goals with your energy project(s)?' ? (
                            <>
                              <InputLabel
                                key="labelForAutocomplete"
                                sx={{
                                  mt: 4,
                                  mb: 1,
                                  whiteSpace: 'unset',
                                  width: '100%',
                                  color: 'black'
                                }}
                              >
                                {question.question}
                              </InputLabel>
                              <Autocomplete
                                multiple
                                limitTags={2}
                                key={question.question}
                                question={question.question}
                                options={goalsOptions}
                                getOptionLabel={option => option}
                                onBlur={handleGoalsBlur}
                                name={question.name}
                                value={selectedGoals}
                                disableCloseOnSelect
                                onChange={(e, newValue) => {
                                  setSelectedGoals(newValue);
                                  setFormState({
                                    ...formState,
                                    goals: newValue
                                  });
                                }}
                                // onChange={newValue => {
                                //   setSelectedGoals(selectedGoals => [
                                //     ...selectedGoals,
                                //     newValue
                                //   ]);
                                //   setFormState({
                                //     ...formState,
                                //     goals: options
                                //   });
                                // }}
                                inputValue={autoInputValue}
                                onInputChange={(event, newInputValue) => {
                                  setAutoInputValue(newInputValue);
                                }}
                                renderInput={params => (
                                  <TextField
                                    {...params}
                                    variant="standard"
                                    placeholder="Please select..."
                                    // onChange={console.log(params)}
                                  />
                                )}
                                // sx={{ width: '200px' }}
                              />
                              {/* <Select
                                question={question.question}
                                key={question.question}
                                variant="standard"
                                name={question.name}
                                onChange={e => handleChange(e)}
                                onBlur={handleRegistrationQuizSubmission}
                                displayEmpty="true"
                                value={formState[question.name]}
                                sx={{ color: 'gray', mb: 2 }}
                                fullWidth
                                multiple
                              >
                                <MenuItem value="">Please Select...</MenuItem>
                                {question.options &&
                                  question.options.map(option => {
                                    return (
                                      <MenuItem value={option} key={option}>
                                        {option}
                                      </MenuItem>
                                    );
                                  })}
                              </Select> */}
                            </>
                          ) : REGISTRATION_VERSION === 'v1' ? (
                            <>
                              <InputLabel
                                sx={{
                                  mt: 4,
                                  mb: 1,
                                  whiteSpace: 'unset',
                                  width: '100%',
                                  color: 'black'
                                }}
                              >
                                {question.question}
                              </InputLabel>

                              <Select
                                question={question.question}
                                variant="standard"
                                name={question.name}
                                onChange={e => handleChange(e)}
                                displayEmpty
                                onBlur={handleRegistrationQuizSubmission}
                                value={formState[question.name]}
                                sx={{ color: 'gray', mb: 2 }}
                                fullWidth
                              >
                                <MenuItem value="">Please Select...</MenuItem>
                                {question.options &&
                                  question.options.map(option => {
                                    return (
                                      <MenuItem value={option} key={option}>
                                        {option}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                              {question.other && otherOrg && (
                                <>
                                  <InputLabel
                                    sx={{
                                      mt: 4,
                                      mb: 1,
                                      width: '100%',
                                      whiteSpace: 'unset',
                                      color: 'black'
                                    }}
                                  >
                                    {question.other[0]}
                                  </InputLabel>
                                  <Input
                                    id={question.other[1]}
                                    autoComplete="new-password"
                                    question={question.other}
                                    name={question.other[1]}
                                    onBlur={handleRegistrationQuizSubmission}
                                    sx={{ color: 'gray', mb: 2 }}
                                    onChange={e => handleChange(e)}
                                    fullWidth
                                  />
                                </>
                              )}
                              {question.employee && isEmployee && (
                                <>
                                  <InputLabel
                                    sx={{
                                      mt: 4,
                                      mb: 1,
                                      whiteSpace: 'unset',
                                      width: '100%',
                                      color: 'black'
                                    }}
                                  >
                                    {question.employee[0]}
                                  </InputLabel>
                                  <Input
                                    id={question.other[1]}
                                    autoComplete="new-password"
                                    question={question.employee[1]}
                                    name={question.employee[1]}
                                    sx={{ mb: 2 }}
                                    onBlur={handleRegistrationQuizSubmission}
                                    onChange={e => handleChange(e)}
                                    fullWidth
                                  />

                                  <InputLabel
                                    sx={{
                                      mt: 3,
                                      mb: 1,
                                      whiteSpace: 'unset',
                                      width: '100%',
                                      color: 'black'
                                    }}
                                  >
                                    {question.employee[2]}
                                  </InputLabel>
                                  <Input
                                    id={question.employee[3]}
                                    autoComplete="new-password"
                                    question={question.employee[3]}
                                    onBlur={handleRegistrationQuizSubmission}
                                    name={question.employee[3]}
                                    onChange={e => handleChange(e)}
                                    sx={{ mb: 2 }}
                                    fullWidth
                                  />
                                </>
                              )}
                            </>
                          ) : (
                            <></>
                          )
                        )}
                      </form>
                    </Box>
                  </Box>
                </>
              )}
              {step === 5 && (
                <Box className="content">
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      height: 105,
                      mt: 5
                    }}
                  >
                    <Typography variant="body" align="justify" gutterBottom>
                      Add one or more properties to your first project.
                    </Typography>
                    <Autocomplete
                      autoHighlight
                      options={options}
                      noOptionsText="Please type to search for an address"
                      value={value}
                      onChange={async (event, newValue, reason) => {
                        setOptions(newValue ? [newValue, ...options] : options);
                        setValue(newValue);
                        if (reason === 'clear') {
                          setPickedAddress(null);
                          setInputValue('');
                          setValue('');
                        }
                        if (reason === 'selectOption') {
                          // console.log('address sent to geocode ->', newValue);
                          const response = await agent.Address.geocode(
                            newValue
                          );
                          // console.log('response from geocode ->', response);
                          const result = response.data?.data?.[0];
                          if (result) {
                            setPickedAddress(result);
                            setSelectedAddresses(addresses => [
                              ...addresses,
                              result
                            ]);
                            addressAddTimer(result.address);
                          }
                        }
                      }}
                      onInputChange={(event, newInputValue) => {
                        if (newInputValue.length >= 3) {
                          setInputValue(newInputValue);
                        }
                      }}
                      renderInput={params => (
                        <TextField
                          {...params}
                          fullWidth
                          placeholder="Type to search ..."
                          InputProps={{
                            ...params.InputProps,
                            startAdornment: (
                              <>
                                <InputAdornment
                                  position="start"
                                  // sx={{ width: 40 }}
                                >
                                  {pickedAddress?.address?.length > 6 ? (
                                    loading ? (
                                      <CircularProgress />
                                    ) : (
                                      <CheckCircleOutlineIcon
                                        sx={{ color: 'green' }}
                                      />
                                    )
                                  ) : null}
                                </InputAdornment>
                                {params.InputProps.startAdornment}
                              </>
                            )
                          }}
                        />
                      )}
                    />
                  </Box>

                  <TableContainer
                    className="scrollBarsHidden"
                    sx={{
                      height: '50vh',
                      overFlowX: 'scroll',
                      marginBottom: 4,
                      width: '100%'
                    }}
                  >
                    {!!uploadedData?.length && (
                      <Box pt={4}>
                        <Table>
                          <TableBody>
                            {uploadedData.map(address => (
                              <TableRow>
                                <TableCell align="left">
                                  <CheckOutlinedIcon
                                    sx={{ color: '#8fc408', fontSize: 20 }}
                                  />
                                </TableCell>
                                {uploadedData && (
                                  <TableCell
                                    align="center"
                                    style={{
                                      textOverflow: 'ellipsis',
                                      overflow: 'hidden',
                                      whiteSpace: 'nowrap',
                                      maxWidth: 200
                                    }}
                                  >
                                    {address}
                                  </TableCell>
                                )}
                                <TableCell align="right">
                                  <ClearIcon
                                    sx={{
                                      color: '#1f1f1f',
                                      fontSize: 20
                                    }}
                                    onClick={e => deleteAddress(e)}
                                    row={address}
                                  />
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </Box>
                    )}
                  </TableContainer>
                </Box>
              )}
              {step === 6 && REGISTRATION_VERSION === 'v1' && (
                <Box className="content">
                  {pickedAddress ? (
                    <Typography sx={{ mt: 6 }}>
                      {uploadedData.length === 1
                        ? `Successfully added ${pickedAddress.address} to your
                      project.`
                        : `Successfully added ${uploadedData.length} sites to your project`}
                    </Typography>
                  ) : (
                    <Typography sx={{ textAlign: 'justify', mt: 6 }}>
                      Are you sure you don&apos;t want to add any properties
                      now?
                    </Typography>
                  )}
                </Box>
              )}
              {step === 6 &&
                REGISTRATION_VERSION === 'v2' &&
                (addressError ? (
                  <Box className="content">
                    {/* <CircularProgress /> */}
                    <Typography sx={{ textAlign: 'justify', mt: 6 }}>
                      There was a problem with one or more of your addresses.
                      Please try again.
                    </Typography>
                  </Box>
                ) : (
                  <Box className="content">
                    <Box>
                      {userStore.isActivated ? (
                        <Typography>
                          Thanks for confirming your email, welcome to
                          Gridmarket.
                        </Typography>
                      ) : (
                        // <Spinner />
                        <Typography>
                          We&apos;ve sent you a confirmation email. Please click
                          the link in that email to activate your account and
                          see your property assessment.
                        </Typography>
                      )}
                    </Box>
                  </Box>
                ))}

              {/* {step === 6 && (
                <Box className="content">
                  <Box>
                    {userStore.isActivated ? (
                      <Typography>
                        Thanks for confirming your email, welcome to Gridmarket.
                      </Typography>
                    ) : (
                      // <Spinner />
                      <Typography>
                        We&apos;ve sent you a confirmation email. Please click
                        the link in that email to activate your account and see
                        your property assessment.
                      </Typography>
                    )}
                  </Box>
                </Box>
              )} */}
              {step >= 3 && step <= 6 && (
                <Box className="react-stepper">
                  <MobileStepper
                    variant="dots"
                    steps={4}
                    position="static"
                    sx={{
                      background: 'transparent'
                    }}
                    activeStep={activeStep}
                    nextButton={
                      <Button
                        size="large"
                        onClick={handleNext}
                        disabled={step === 6}
                      >
                        {step < 7 ? 'Next' : null}

                        {theme.direction === 'rtl' && activeStep < 4 ? (
                          <KeyboardArrowLeft />
                        ) : activeStep < 4 ? (
                          <KeyboardArrowRight />
                        ) : null}
                      </Button>
                    }
                    backButton={
                      <Button
                        size="large"
                        onClick={activeStep === 0 ? handleSkip : handleBack}
                        disabled={activeStep === 2 && userStore.isActivated}
                      >
                        {theme.direction === 'rtl' ? (
                          <KeyboardArrowRight />
                        ) : activeStep > 0 ? (
                          <KeyboardArrowLeft />
                        ) : null}
                        {activeStep === 0 ? 'Skip' : 'Back'}
                        {activeStep === 0 && theme.direction === 'ltr' && (
                          <KeyboardDoubleArrowRightIcon />
                        )}
                        {activeStep === 0 && theme.direction === 'rtl' && (
                          <KeyboardDoubleArrowLeftIcon />
                        )}
                      </Button>
                    }
                  />
                </Box>
              )}
            </Box>
            <Box className="bg" />
          </Box>
        </LayoutPanel>
      }
    />
  );
};

export default observer(Onboarding);
